export default class ToggleMenu {
    constructor() {
        this.menu = document.querySelector(".jsToggleMenu");
        this.body = document.body;
        this.navbar = document.querySelector(".main-menu__mobile-menu");

        this.events();
    }

    events() {
        this.menu.addEventListener("click", () => {
            this.toggleMenu();
        });

        document.querySelectorAll(".main-menu__link").forEach((link) => {
            link.addEventListener("click", () => {
                this.removeMenu();
            });
        });
    }

    toggleMenu() {
        this.menu.classList.toggle("on");
        if (this.menu.classList.contains("on")) {
            this.body.style.overflow = "hidden";
            this.body.style.height = "100%";
            this.body.querySelector(".main-menu").style.backgroundColor =
                "transparent";
        } else {
            this.body.style.overflow = "auto";
            this.body.style.height = "auto";
            this.body.querySelector(".main-menu").style.backgroundColor =
                "#24292b";
        }
        this.navbar.classList.toggle("active");
    }

    removeMenu() {
        this.body.style.overflow = "auto";
        this.body.style.height = "auto";

        this.menu.classList.remove("on");
        this.navbar.classList.remove("active");
        this.body.querySelector(".main-menu").style.backgroundColor = "#24292b";
    }
}
